export default __webpack_public_path__ + "static/media/banner3.7f7130d7.jpg";